import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import * as React from "react";
import TitleCustom from "components/CustomTitle";
import MDBox from "components/MDBox";
import { Alert, Grid } from "@mui/material";
import CommonSelect from "components/CommonSelect/select";
import { companiesSync } from "rest/sync/requestsSync";
import { useState } from "react";
import getTableData from "./formatTableData";
import DataTable from "examples/Tables/DataTable";
import { useCallback } from "react";
import { useEffect } from "react";
import { getUsers } from "rest/requests";
import { findUsersByCompany } from "rest/requests";
import EditUsers from "./editUsers";
import MDButton from "components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import { getExcelData } from "./getExcelData";
import { notificacion } from "rest/requests";

function AensaUsers() {
  const companiesCatalog = companiesSync();
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [users, setUsers] = useState([]);
  const [userToEdit, setUserToEdit] = useState(null);
  const [isEditingUser, setIsEditingUser] = useState(false);
  let now = new Date();
  let anio3 = now.getFullYear();

  const getNotificacion = useCallback(async () => {
    try {
      const response = await fetch(notificacion(anio3));
      Alert("SE HA ENVIADO UN EMAIL CON LOS RESULTADOS");
      console.error("Error fetching data:", response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, []);
  const getUsersData = useCallback(async () => {
    if (selectedCompany) {
      setUsers(await findUsersByCompany(1, selectedCompany));
    } else {
      setUsers(await getUsers());
    }
  }, [selectedCompany, isEditingUser]);

  useEffect(() => {
    getUsersData();
  }, [selectedCompany]);

  useEffect(() => {
    getUsersData();
  }, [isEditingUser]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TitleCustom
        title={"Administración Usuarios"}
        excelData={getExcelData(users)}
        excelName={"Administracion_de_Usuarios.xlsx"}
      ></TitleCustom>
      <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
        <Grid container spacing={5}>
          <Grid item>
            <CommonSelect
              data={companiesCatalog}
              onChange={(selectedValue) => setSelectedCompany(selectedValue)}
            ></CommonSelect>
          </Grid>
        </Grid>
        {!isEditingUser ? (
          <MDButton
            variant="text"
            size="small"
            color="secondary"
            onClick={() => {
              setUserToEdit(null);
              setIsEditingUser(true);
            }}
          >
            <AddIcon></AddIcon>
            Adicionar Usuario
          </MDButton>
        ) : (
          <></>
        )}
        <MDButton variant="contained" size="small" color="dark" onClick={getNotificacion}>
          Notificar Variación
        </MDButton>
      </MDBox>
      <br></br>
      {isEditingUser ? (
        <EditUsers userToEdit={userToEdit} setIsEditingUser={setIsEditingUser} />
      ) : (
        <div>
          <DataTable
            table={getTableData(users, setIsEditingUser, setUserToEdit)}
            canSearch={true}
          />
        </div>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default AensaUsers;
